<template>
  <div class="mb-1">
    <multiple-select-input
      id="rolesSelect"
      :model.sync="selectedRoles"
      :values="getRoles"
      :multiple="false"
    >
    </multiple-select-input>

    <div class="map-section" v-if="!userRolesLoading">
      <gmap-map
        ref="mainMap"
        :center="startLocation"
        :zoom="6"
        map-type-id="roadmap"
        style="width: 100%; height: 100%"
        :options="{
          zoomControl: true,
          scaleControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          streetViewControl: false,
          disableDefaultUi: false,
        }"
      >
        <gmap-marker
          v-for="(item, key) in coordinates"
          :key="key"
          :position="getPosition(item)"
          :clickable="true"
          :icon="icon"
          @click="toggleInfo(item, key)"
        ></gmap-marker>
      </gmap-map>
      <transition name="map-info-window-slide">
        <div
          class="map-info-window"
          :opened="infoOpened"
          :position="infoPosition"
          v-if="infoOpened"
        >
          <div class="city-info" v-if="selectedMarker">
            <div class="city-location">{{$t('dashboard.name')}}:{{ selectedMarker.name }}</div>
            <div class="city-location">{{$t('dashboard.surname')}}:{{ selectedMarker.surname }}</div>
            <div class="city-location">{{$t('dashboard.role')}}:{{ selectedMarker.role }}</div>
            <div class="map-btn-close-holder">
              <button
                class="btn btn-danger map-btn-close"
                @click="closeInfoWindow()"
              >
                {{ $t("dashboard.close") }}
              </button>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="row" v-else>
      <div class="col-12">
        <loading-box></loading-box>
      </div>
    </div>

    <!--end:: Google Map Section-->
  </div>
</template>
  
<script>
import LoadingBox from "../../../assets/components/loader/LoadingBox.vue";
import MultipleSelectInput from "../../../assets/components/inputs/MultipleSelectInput.vue";
import baseModule, {
  ERROR,
  MODULE_NAME,
  USER_ROLES,
  USER_HISTORIES,
  GET_USER_ROLES,
  GET_USER_HISTORIES,
  GET_USER_HISTORIES_LOADING,
  SUCCESS,
} from "@/core/services/store/dashboard.module";
import store from "@/core/services/store";

const _MODULE_NAME = MODULE_NAME;

export default {
  name: "DashboardUsersMap",
  components: {
    MultipleSelectInput,
    LoadingBox,
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
    registerStoreModule(_MODULE_NAME, baseModule);
  },
  data: function () {
    return {
      selectedRoles: null,
      allRoles: [],
      startLocation: {
        lat: 39.5708783,
        lng: 35.6807645,
      },
      icon: null,
      iconList: [
        {
          url: "http://masima.limonist.ist/public/assets/images/black.png",
          size: { width: 40, height: 40, f: "px", b: "px" },
          scaledSize: { width: 40, height: 40, f: "px", b: "px" },
        },
        {
          url: "http://masima.limonist.ist/public/assets/images/danger.png",
          size: { width: 40, height: 40, f: "px", b: "px" },
          scaledSize: { width: 40, height: 40, f: "px", b: "px" },
        },
        {
          url: "http://masima.limonist.ist/public/assets/images/marker.png",
          size: { width: 40, height: 40, f: "px", b: "px" },
          scaledSize: { width: 40, height: 40, f: "px", b: "px" },
        },
        {
          url: "http://masima.limonist.ist/public/assets/images/success.png",
          size: { width: 40, height: 40, f: "px", b: "px" },
          scaledSize: { width: 40, height: 40, f: "px", b: "px" },
        },
        {
          url: "http://masima.limonist.ist/public/assets/images/warning.png",
          size: { width: 40, height: 40, f: "px", b: "px" },
          scaledSize: { width: 40, height: 40, f: "px", b: "px" },
        },
      ],
      coordinates: [],
      selectedKey: null,
      selectedMarker: null,
      infoOpened: false,
    };
  },
  mounted() {
    this.filterAllRoleMapData();
    this.filterResults();
    this.getRoles;
    this.icon = this.iconList[_.random(1, 4)];
  },
  computed: {
    error() {
      return store.getters[_MODULE_NAME + "/" + ERROR];
    },
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
    userRoles() {
      return store.getters[_MODULE_NAME + "/" + USER_ROLES];
    },
    userHistories() {
      return store.getters[_MODULE_NAME + "/" + USER_HISTORIES];
    },
    getRoles() {
      let roles = this.userRoles;
      if (!roles) return 0;
      return roles.rolesCount;
    },
    userRolesLoading() {
      return store.getters[_MODULE_NAME + "/" + GET_USER_HISTORIES_LOADING];
    },
  },
  methods: {
    async filterAllRoleMapData() {
      await this.$store.dispatch(_MODULE_NAME + "/" + GET_USER_HISTORIES, {});
      this.editedForMapHistory();
    },
    async filterUserRolesMap() {
      await this.$store.dispatch(_MODULE_NAME + "/" + GET_USER_HISTORIES, {
        filters: {
          id: this.selectedRoles,
        },
      });

      this.editedForMapHistory();
    },
    editedForMapHistory() {
      this.coordinates = [];
      let mapData = this.userHistories;
      mapData.forEach((coordinate) => {
        this.coordinates.push({
          lat: coordinate.latitude,
          lng: coordinate.longitude,
          name: coordinate.name,
          surname: coordinate.surname,
          role: coordinate.role,
        });
      });
    },
    filterResults() {
      this.$store.dispatch(_MODULE_NAME + "/" + GET_USER_ROLES, {});
    },
    getMarkers(key) {
      if (this.selectedKey === key) return this.mapMarkerActive;
      return this.mapMarker;
    },
    getPosition: function (marker) {
      return {
        lat: parseFloat(marker.lat),
        lng: parseFloat(marker.lng),
      };
    },
    toggleInfo: function (marker, key) {
      this.infoPosition = this.getPosition(marker);
      this.selectedMarker = marker;
      this.selectedKey = key;
      this.infoOpened = !this.infoOpened;
    },
    closeInfoWindow: function () {
      this.infoOpened = false;
      this.markerOptions = this.mapMarker;
    },
  },
  watch: {
    selectedRoles() {
      this.filterUserRolesMap();
      let randomIcon = this.iconList[_.random(1, 4)];
      this.icon = randomIcon;
    },
  },
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#rolesSelect {
  position: absolute;
  z-index: 99;
  top: 4px;
  width: 350px;
  right: 5px;
}
.map-section {
  height: 500px;
  position: relative;
  overflow: hidden;
}

.map-info-window {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  background: #fff;
}

.map-info-window-slide-leave-active,
.map-info-window-slide-enter-active {
  transition: 0.5s;
}

.map-info-window-slide-enter {
  transform: translate(0, -100%);
}

.map-info-window-slide-leave-to {
  transform: translate(0, -100%);
}

.city-info > div {
  margin-bottom: 10px;
}

.map-btn-close-holder {
  margin-top: 10px;
}
</style>
  